import {RemoteGetContractualTermPending} from 'data/usecases/private/home/remote-get-contractual-term-pending';
import {GetContractualTermPending} from 'domain/usecases/private/home/get-contractual-term-pending';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetContractualTermPending = (): GetContractualTermPending =>
	new RemoteGetContractualTermPending(
		makeBFFApiUrl(HomeEndPoints.contractualTermPending),
		makeAuthorizeHttpClientDecorator(),
	);
